import styled from 'styled-components';
import colors from 'constants/colors';

export const ReconciliationTableContainer = styled.table`
  width: 100%;
  color: ${colors.white};
  border-collapse: collapse;
  font-size: 14px;
  margin-top: 32px;
  background-color: ${colors.black2};

  th {
    height: 20px;
    vertical-align: bottom;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${colors.darkGrey};
    color: ${colors.silver};
  }

  td {
    height: 42px;
    padding: 16px 0;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${colors.white};
    border-bottom: 1px solid ${colors.darkGrey};
    :first-child {
      a {
        color: ${colors.white};
      }
    }
  }

  .booking-code {
    width: 9%;
  }

  .charge-date {
    width: 9%;
  }

  .customer-name {
    width: 11%;
  }

  .number-of-rooms {
    width: 8%;
  }

  .lodging {
    width: 6%;
  }

  .misc {
    width: 4%;
  }

  .subtotal {
    width: 6%;
  }

  .MAT {
    width: 4%;
  }

  .HST {
    width: 4%;
  }

  .total-charged {
    width: 10%;
  }

  .charge-type {
    width: 8%;
  }

  .check-in {
    width: 6%;
  }

  .check-out {
    width: 7%;
  }

  .booking-fee {
    width: 8%;
  }
`;

export const NavigatorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 10px;

  /* @media only screen and (max-width: 1200px) {
    justify-content: center;
  } */
`;

export const Navigator = styled.div`
  color: ${colors.lightBlue};
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;

  /* @media only screen and (max-width: 1200px) {
    display: none;
  } */

  ${(props) => props.disabled ? `
    pointer-events:none;
    color: ${colors.dimGrey}
  `: null }
`;

export const SubHeaderContainer = styled.div`
  width: 100%;
  height: 50px;
  background-color: ${colors.charcoal};
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;

  .filterContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .datePicker {
      margin: 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      span {
        font-size: 12px;
        margin-right: 5px;
        color: ${colors.white};
      }
    }

    .dataType {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .title {
        font-size: 12px;
        font-weight: 600;
        color: ${colors.silver};
        white-space: nowrap;
      }
    }
  }


`;
